import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store";
import { subscribeToWalletAndTransactions } from "../store/slices/walletSlice";
import { useAppSelector } from "../store/hooks";

export const useWallet = () => {
  const user = useAppSelector((state) => state?.user?.user);
  const dispatch = useDispatch();
  const wallet = useSelector((state: RootState) => state?.wallet?.wallet);
  const transactions = useSelector(
    (state: RootState) => state?.wallet?.transactions
  );
  const id =
    user?.teamRole === "customer_owner" || user?.uiRole === "expert_owner"
      ? user?.uid
      : user?.teamRole === "customer_team_lead" ||
        user?.uiRole === "customer_team_lead" ||
        user?.teamRole === "customer_team_member" ||
        user?.uiRole === "customer_team_member" ||
        user?.teamRole === "expert_team_lead" ||
        user?.uiRole === "expert_team_lead" ||
        user?.teamRole === "expert_team_member" ||
        user?.uiRole === "expert_team_member" ||
        user?.role === "supporty_admin"
      ? user?.uid
      : "";
  const error = useSelector((state: RootState) => state?.wallet?.error);
  useEffect(() => {
    if (
      (user?.role !== "Expert" ||
        user?.role === "Customer" ||
        user?.role !== "supporty_admin") &&
      id // Only subscribe if id is not empty
    ) {
      const unsubscribe = dispatch(subscribeToWalletAndTransactions(id));

      // Clean up listener on component unmount
      return () => {
        if (unsubscribe) unsubscribe();
      };
    }
    // Optionally, handle/log the case where id is empty
    // else {
    //   console.warn("No valid wallet id for subscription");
    // }
  }, [dispatch, id, user?.role]);

  return { wallet, transactions, error };
};
